import React from 'react';

import PropTypes from 'prop-types';

import { Mui } from '../..';
import * as DisplayData from '../DisplayData';
import { TUITION_STATUS } from '../DisplayStatus/Order';
import Base from './Base';

function Tuition(props) {
  const { changes, ...otherProps } = props;

  const theme = Mui.useTheme();
  const fullScreen = Mui.useMediaQuery(theme.breakpoints.down('sm'));

  const steps = changes.map(change => ({
    color: TUITION_STATUS[change.status].color,
    icon: <Mui.Icon>{TUITION_STATUS[change.status].icon}</Mui.Icon>,
    status: change.status,
    label: change.statusDisplay,
    optional: !!change.dateCreated || !!change.date,
    optionalLabel: (
      <DisplayData.DateField type="datetime" value={change.dateCreated || change.date} />
    ),
  }));

  /**
   * The usual workflow is mounted depending
   * of the last step in changes
   */
  if (steps[steps.length - 1]?.status === 'pending') {
    steps.push(TUITION_STATUS.active);
  }
  if (steps[steps.length - 1]?.status === 'active') {
    steps.push(TUITION_STATUS.finished);
  }
  if (steps[steps.length - 1]?.status === 'cancellation-requested') {
    steps.push(TUITION_STATUS.canceled);
  }

  return (
    <Base
      steps={steps}
      alternativeLabel={!fullScreen}
      orientation={fullScreen ? 'vertical' : 'horizontal'}
      activeStep={changes.length - 1}
      {...otherProps}
    />
  );
}

Tuition.propTypes = {
  changes: PropTypes.array.isRequired,
};

export default Tuition;
